class Controller {
  constructor(Events, $stateParams) {
    "ngInject";

    this.addItemEvent = Events.getAddEvent("packages");
    this.paginateEvent = Events.getPaginateEvent("packages");
    this.filterEvent = Events.getFilterEvent("packages");
    this.sortEvent = Events.getSortEvent("packages");
    this.page = $stateParams.page;
    this.limit = $stateParams.limit;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/packages/packages.controller.js